import React from 'react';
import { Trans } from 'react-i18next';
import i18next from 'i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withState, compose } from 'recompose';
import * as R from 'ramda';
import moment from 'moment';

import { modalsConstants } from '../../../../modules/modals';

import { IconBtnS, Text } from '../../common';
import { DisplayFlexS } from '../../../../utils/stylesHelpers';
import { COMMENT_WORKFLOW_STATES } from '../../../constants/comments';

import {
  AnswerWrap,
  ControlsBtns,
  ControlsBtn,
  Date,
  HistoryLogWrap,
  Item,
  Name,
  NameAuthor,
  NameText,
  ChangeText,
  EditBtnsCancel,
  EditBtns, NameCompany, RatingWrap
} from './AdminManagmentCommentsS';
import { GreyBtnS } from '../../common/Button';
import Rating from "react-rating";
import StarImg from "../../../assets/imgs/star-without-bg.svg";
import StartWithBg from "../../../assets/imgs/star-with-bg.svg";

const { MODAL_TYPES } = modalsConstants;

const CommentItemComponent = ({
  comment,
  isEditing,
  setIsEditing,
  textToEdit,
  setTextToEdit,
  answerTextToEdit,
  setAnswerTextToEdit,
  setModalStateFor,
  editCommentByAdmin,
}) => {
  const withAnswer = comment.companyAnswer;

  const renderActionBtns = workflow => (
    <ControlsBtns aItems="flex-end" direction="column">
      {
        workflow === COMMENT_WORKFLOW_STATES.DELETED &&
        <HistoryLogWrap aItems="flex-end" direction="column">
          <Text color="primaryGray"><Trans i18nKey="adminPanel.comments.commentStates.deleted"/></Text>
          <Text color="primaryGray">{moment(comment.deletedAt || withAnswer.deletedAt).format('HH:mm, D MMM YYYY')}</Text>
        </HistoryLogWrap>
      }
      {
        workflow === COMMENT_WORKFLOW_STATES.EDITED && (comment.editedAt || R.path(['companyAnswer', 'editedAt'], comment)) && /* TODO: this field isn`t supported on server it can be changed. (temp solution) */
        <HistoryLogWrap aItems="flex-end" direction="column">
          <Text color="primaryGray"><Trans i18nKey="adminPanel.comments.commentStates.updated"/></Text>
          <Text color="primaryGray">
            {moment(comment.editedAt || withAnswer.editedAt).format('HH:mm, D MMM YYYY')}
          </Text>
        </HistoryLogWrap>
      }
      {
        workflow === COMMENT_WORKFLOW_STATES.POSTED && (comment.postedAt || R.path(['postedAt'], withAnswer)) &&
        <HistoryLogWrap aItems="flex-end" direction="column">
          <Text color="primaryGray"><Trans i18nKey="adminPanel.comments.commentStates.posted"/></Text>
          <Text color="primaryGray">{moment(comment.postedAt || withAnswer.postedAt).format('HH:mm, D MMM YYYY')}</Text>
        </HistoryLogWrap>
      }
      {
        workflow !== COMMENT_WORKFLOW_STATES.DELETED &&
        <ControlsBtn aItems="center" justify="flex-end">
          {
            workflow !== COMMENT_WORKFLOW_STATES.POSTED &&
            <IconBtnS
              iconName="sticky-note"
              color="green"
              bgColorHover="shamRockAlpha"
              title={i18next.t("adminPanel.comments.controlButtons.posted")}
              onClick={() => setModalStateFor(MODAL_TYPES.POST_COMMENT_CONFIRMATION, { open: true, id: comment._id })}
            />
          }
          <IconBtnS
            iconName="edit"
            color="greyYellow"
            bgColorHover="tulipTreeAlpha"
            title={i18next.t("adminPanel.comments.controlButtons.edit")}
            onClick={() => setIsEditing(true)}
          />
          <IconBtnS
            iconName="trash-alt"
            color="red"
            bgColorHover="redAlpha"
            title={i18next.t("adminPanel.comments.controlButtons.delete")}
            onClick={() => setModalStateFor(MODAL_TYPES.DELETE_COMMENT_CONFIRMATION, { open: true, id: comment._id })}
          />
        </ControlsBtn>
      }
    </ControlsBtns>
  );

  const renderCommentControlBtns = () => (
    <EditBtns>
      <GreyBtnS
        padding="10px"
        fz="smallText"
        onClick={() => {
          setIsEditing(false);
          setTextToEdit(null);
          setAnswerTextToEdit(null);
        }}
      >
        <Trans i18nKey="adminPanel.comments.modals.cancelBtn"/>
      </GreyBtnS>
      <EditBtnsCancel
        onClick={() => {
          editCommentByAdmin(comment._id, (textToEdit || answerTextToEdit)); // send to redux
          setAnswerTextToEdit(null);
          setTextToEdit(null);
          setIsEditing(false);
        }}
        padding="10px"
        fz="smallText"
      >
        <Trans i18nKey="adminPanel.comments.saveBtn"/>
      </EditBtnsCancel>
    </EditBtns>
  );

  const renderCommentAnswer = () => (
    <AnswerWrap>
      <DisplayFlexS direction="column">
        <Name aItems="center">
          <FontAwesomeIcon icon="comments"/>
          <NameText><Trans i18nKey="adminPanel.comments.commentsResponse"/></NameText>
          <NameAuthor color="darkerViolet" weight="bold">
            {comment.company.name}
          </NameAuthor>
        </Name>
        <ChangeText
          isEdit={withAnswer && isEditing}
          onChange={({ target }) => setAnswerTextToEdit(target.value)}
          value={answerTextToEdit || withAnswer.text}
        >
          {withAnswer.text}
        </ChangeText>
        <Date align="left">
          {moment(withAnswer.createdAt).format('HH:mm, D MMM YYYY')}
        </Date>
        {withAnswer && isEditing && renderCommentControlBtns()}
      </DisplayFlexS>
      {renderActionBtns(withAnswer.workflowState)}
    </AnswerWrap>
  );

  const commentCreatorComment = withAnswer ? 'gray_1' : [COMMENT_WORKFLOW_STATES.POSTED, COMMENT_WORKFLOW_STATES.DELETED] ? 'primary' : 'darkerViolet';

  return (
    <Item
      workflowState={isEditing ? COMMENT_WORKFLOW_STATES.EDITED : !withAnswer ? comment.workflowState : withAnswer.workflowState }
    >
      <DisplayFlexS direction="column">
        <NameCompany size="largeText" weight="bold" color={commentCreatorComment}>{R.pathOr('-', ['company', 'name'], comment)}</NameCompany>
        <Name grayed={withAnswer} aItems="center">
          <FontAwesomeIcon icon="comment"/>
          <NameText color={commentCreatorComment}><Trans i18nKey="adminPanel.comments.commentsName"/></NameText>
          <NameAuthor color={commentCreatorComment} weight="bold">{comment.createdBy.name}
            <Text color={commentCreatorComment} weight="normal"> - {comment.createdBy.email}</Text>
          </NameAuthor>
        </Name>

        {
          comment.rating > 0 && <RatingWrap>
            <Rating
              readonly
              initialRating={comment.rating}
              emptySymbol={<img src={StarImg} alt="rating-start"/>}
              fullSymbol={<img src={StartWithBg} alt="rating-start"/>}
            />
          </RatingWrap>
        }

        <ChangeText
          isEdit={!withAnswer && isEditing}
          onChange={({ target }) => setTextToEdit(target.value)}
          value={textToEdit || comment.text}
          grayed={withAnswer}
        >
          {comment.text}
        </ChangeText>
        <Date
          color={withAnswer ? 'gray_1' : 'inherit'}
          align="left"
        >
          {moment(comment.createdAt).format('HH:mm, D MMM YYYY')}
        </Date>
        {!withAnswer && isEditing && renderCommentControlBtns()}
        {withAnswer && renderCommentAnswer()}
      </DisplayFlexS>

      {!withAnswer && renderActionBtns(comment.workflowState)}

    </Item>)
};

export default compose(
  withState('isEditing', 'setIsEditing', false),
  withState('textToEdit', 'setTextToEdit', null),
  withState('answerTextToEdit', 'setAnswerTextToEdit', null)
)(CommentItemComponent);
